import React, { useState } from 'react'
import Select from 'react-select'

export default function InputModal({handleClose, saving, handleInvite, userType, groups = [] }) {
    const [message, setMessage] = useState('')
    const [selectedGroup, setSelectedGroup] = useState(groups ? groups[0] : null)

    const validateData = () => {
        if (userType == 'group' && !selectedGroup) {
            Alert.show('notice', 'You need to select a group to send group invites')
            return
        }

        handleInvite(message, userType, selectedGroup)
    }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                    <div>
                    {saving &&
                        <div>Please wait while we send invites</div>
                    }
                    <div class="row">
                        <div class="col-md-12">
                            {userType == 'group' &&
                                <div className='form-group'>
                                    <label id="postAsLabel">Select Group</label>
                                    <div className="input-group">
                                        <Select
                                            className="w-100"
                                            onChange={(group) => {
                                                setSelectedGroup(group)
                                            }}
                                            options={groups}
                                            getOptionLabel={(group) =>
                                                `${group.name}`
                                            }
                                            getOptionValue={(group) => group.id}
                                            value={selectedGroup}
                                        />
                                    </div>
                                </div>
                            }
                            <div class="form-group">
                                <label for="bio">Enter Custom Message</label>
                                <textarea 
                                    value={message} class="form-control"
                                    onChange={(e) => setMessage(e.target.value)}
                                    disabled={saving}
                                >
                                </textarea>
                                <p className="mb-0 mt-1"><b>Note: </b> This message will replace the standard email</p>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="pt-3">
                        <button onClick={validateData} type="button" className="btn btn-primary mr-2" disabled={saving}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Send Invites
                        </button>

                        <button onClick={handleClose} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                            Cancel
                        </button>
                    </div>
                </div>
    </div>
    </div>
  )
}
